import type { Course } from "@brookbush/types";

import AuthorCard from "~/components/AuthorCard";

interface Props {
	authors: Course["authors"];
}

const CourseAuthors = ({ authors }: Props) => {
	return (
		<div className="mx-auto flex flex-col items-center gap-4 sm:gap-6">
			<h2 className="font-semibold text-2xl sm:text-2xl">Authors</h2>

			<div className="flex w-full phablet:flex-row flex-col flex-wrap gap-5 sm:justify-start">
				{authors.map((author) => (
					<AuthorCard key={author._id} author={author} />
				))}
			</div>
		</div>
	);
};

export default CourseAuthors;
